import { Outlet } from 'react-router-dom';

import { ScreenRecordModal } from '@/widgets/createProject';

export const AuthRoutes = () => (
  <>
    <Outlet />
    <ScreenRecordModal />
  </>
);
